// extracted by mini-css-extract-plugin
export default {"pricesBlock":"styles_prices-block__Rv6IU","pricesBlock__title":"styles_prices-block__title__bv-yI","pricesBlock__item":"styles_prices-block__item__9TKgW"};